<style>
.container-mis-rep {
  display: flex;
  justify-content: center;
  height: 100%;
  padding: 20px;
}

.centered-content-mis-rep {
  padding: 20px;
  /*background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 8px;*/
  width: 100%;
  max-width: 250px;
  box-sizing: border-box;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <!-- <b-card-header header-tag="header" class="p-1" role="tab"></b-card-header> -->
      <b-card-body>
        <div class="container-mis-rep">
          <div class="centered-content-mis-rep">
            <div style="font-weight:bold; margin-bottom:20px">Seleccione una opción</div>
            <div style="display: flex; align-items: center; gap: 50px; width:600px">
              <div>
                <b-button
                  :disabled="Model.HasTyCAccepted_DebinSpot === false"
                  class="btn btn-success"
                  @click="GoToDebinSpot()"
                >Debin Spot</b-button>
              </div>
              <div
                style="display: flex; align-items: center; gap: 6px;"
                v-if="Model.HasTyCAccepted_DebinSpot === false"
              >
                <resimple-switch
                  class="ml-2"
                  v-on:change="AceptTermsAndConditions(Model.tycDebinSpot)"
                />
                <a
                  href="https://www.resimple.com.ar/legales/"
                  target="_blank"
                >Términos y condiciones Debin Spot</a>
              </div>
            </div>
            <div style="margin-top: 10px; display: flex; align-items: center; gap: 50px; width:600px">
              <div>
                <b-button
                  :disabled="Model.HasTyCAccepted_DebinRecurrente === false"
                  class="btn btn-success"
                  @click="GoToOtrasOpcionesRecurrencias()"
                >Debin Recurrente</b-button>
              </div>
              <div
                style="display: flex; align-items: center; gap: 6px;"
                v-if="Model.HasTyCAccepted_DebinRecurrente === false"
              >
                <resimple-switch
                  class="ml-2"
                  v-on:change="AceptTermsAndConditions(Model.tycDebinRecurrente)"
                />
                <a
                  href="https://www.resimple.com.ar/legales/"
                  target="_blank"
                >Términos y condiciones Debin Recurrente</a>
              </div>
            </div>
             <div style="margin-top: 10px; display: flex; align-items: center; gap: 50px; width:600px">
              <div>
                <b-button
                  :disabled="Model.HasTyCAccepted_DebinProgramado === false"
                  class="btn btn-success"
                  @click="OtrasOpcionesRecurrenciasDebinProgramado()"
                >Debin Programado</b-button>
              </div>
              <div
                style="display: flex; align-items: center; gap: 6px;"
                v-if="Model.HasTyCAccepted_DebinProgramado === false"
              >
                <resimple-switch
                  class="ml-2"
                  v-on:change="AceptTermsAndConditions(Model.tycDebinProgramado)"
                />
                <a
                  href="https://www.resimple.com.ar/legales/"
                  target="_blank"
                >Términos y condiciones Debin Programado</a>
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import ResimpleSwitch from "@/components/Custom/ResimpleSwitch";

export default {
  components: { "resimple-switch": ResimpleSwitch },
  data() {
    return {
      Model: {
        tycDebinSpot: 0,
        HasTyCAccepted_DebinSpot: false,
        tycDebinRecurrente: 0,
        HasTyCAccepted_DebinRecurrente: false,
        tycDebinProgramado: 0,
        HasTyCAccepted_DebinProgramado: false
      }
    };
  },
  methods: {
    GoToDebinSpot() {
      let context = this;

      context.$router.push({
        name: "DebinSpot"
      });
    },
    GoToOtrasOpcionesRecurrencias() {
      let context = this;

      context.$router.push({
        name: "OtrasOpcionesRecurrencias"
      });
    },
    OtrasOpcionesRecurrenciasDebinProgramado() {
      let context = this;

      context.$router.push({
        name: "OtrasOpcionesRecurrenciasDebinProgramado"
      });
    },
    HasLastVersionTermsAndConditionsAccepted(IdTypeTyC) {
      let context = this;

      axiosHelpers.axiosGet(
        "Account/HasLastVersionTermsAndConditionsAccepted",
        { IdTermsAndConditionsType: IdTypeTyC },
        context,
        function(response) {
          if (IdTypeTyC == context.Model.tycDebinSpot) {
            context.Model.HasTyCAccepted_DebinSpot =
              response.ResponseVM.HasTermsAndConditionsAccepted;
          }

          if (IdTypeTyC == context.Model.tycDebinRecurrente) {
            context.Model.HasTyCAccepted_DebinRecurrente =
              response.ResponseVM.HasTermsAndConditionsAccepted;
          }

          if (IdTypeTyC == context.Model.tycDebinProgramado) {
            context.Model.HasTyCAccepted_DebinProgramado =
              response.ResponseVM.HasTermsAndConditionsAccepted;
          }
        }
      );
    },
    initialize() {
      let context = this;

      context.Model.tycDebinSpot = context.$store.getters.TYC_DEBIN_SPOT;
      context.HasLastVersionTermsAndConditionsAccepted(
        context.Model.tycDebinSpot
      );

      context.Model.tycDebinRecurrente =
        context.$store.getters.TYC_DEBIN_RECURRENTE;
      context.HasLastVersionTermsAndConditionsAccepted(
        context.Model.tycDebinRecurrente
      );

      context.Model.tycDebinProgramado =
      context.$store.getters.TYC_DEBIN_PROGRAMADO;
      context.HasLastVersionTermsAndConditionsAccepted(
        context.Model.tycDebinProgramado
      );
    },
    AceptTermsAndConditions(IdTypeTyC) {
      let context = this;

      axiosHelpers.axiosPost(
        "Account/AcceptTermsAndConditionsForType",
        { IdTermsAndConditionsType: IdTypeTyC },
        context,
        function(response) {
          if (IdTypeTyC == context.Model.tycDebinSpot) {
            context.Model.HasTyCAccepted_DebinSpot =
              response.ResponseVM.Success;
          }

          if (IdTypeTyC == context.Model.tycDebinRecurrente) {
            context.Model.HasTyCAccepted_DebinRecurrente =
              response.ResponseVM.HasTermsAndConditionsAccepted;
          }

          if (IdTypeTyC == context.Model.tycDebinProgramado) {
            context.Model.HasTyCAccepted_DebinProgramado =
              response.ResponseVM.HasTermsAndConditionsAccepted;
          }
        }
      );
    }
  },
  mounted() {
    this.initialize();
  }
};
</script>